export default __webpack_public_path__ + "images/early_termination_invoice_calculation.png";